import { Component, OnInit } from '@angular/core';
import { AllPageService } from "src/app/shared/services/all-page.service";
import { Track } from 'ngx-audio-player';
declare var jQuery: any;
declare var $: any; 

@Component({
  selector: 'app-podcast',
  templateUrl: './podcast.component.html',
  styleUrls: ['./podcast.component.scss']
})
export class PodcastComponent implements OnInit {

  bannerrequest: any = {};
  podcastList: any = "";    
  bannerList: any = "";
  videorequest: any = {
	pagesize: 6,
	page: 1,
	video_catagory_id: 1
  };
  podcastrequest: any = {
	pagesize: 6,
	page: 1
  };
  videoList: any = "";
  videoList_last_page: boolean;
  msaapDisplayTitle = false;
  msaapDisplayPlayList = false;
  msaapPageSizeOptions = [1];
  msaapDisplayVolumeControls = false;
  msaapDisplayRepeatControls = false;
  msaapDisplayArtist = false;
  msaapDisplayDuration = false;
  msaapDisablePositionSlider = false;
  podcastList_last_page: boolean;

  // Material Style Advance Audio Player Playlist
msaapPlaylist: Track[] = [
  {
      title: 'Audio One Title',
      link: 'http://localhost:4200/assets/images/file_example_MP3_700KB.mp3'
  }
];

  constructor(private allpagesService: AllPageService,) {  this.loadpodcast();}

  ngOnInit() {

    this.loadBanner();
    this.loadpodcast();
    
    jQuery(".latest-video-box").slice(0, 12).show();
	  jQuery("#loadMore").on("click", function(e){
	    e.preventDefault();
	    jQuery(".latest-video-box:hidden").slice(0, 12).slideDown();
	    if(jQuery(".latest-video-box:hidden").length == 0) {
	      jQuery("#loadMore").text("No Content").addClass("noContent");
	    }
	});
  }

  loadBanner() {
		this.bannerrequest = {
			title : 'Podcast'
		};
		let request = Object.assign({}, this.bannerrequest);
		this.allpagesService.getBannerList(request).then((data: any) => {
			this.bannerList = data.data[0];
			console.log(this.bannerList);
		});
	}

	getMorePodcast() {
		this.podcastrequest.page = this.podcastrequest.page + 1;
		this.loadpodcast(true);
		
	  }

	loadpodcast(concat:boolean = false) {
		
		let request = Object.assign({}, this.podcastrequest)
				this.allpagesService.getPodcast(request).then((data : any) => { 
				if(data.data.length > 0)
				{
					this.podcastList = data.data;
					this.podcastList.forEach(item => {
						item.msaapPlaylist =  [
							{
								link: item.audio_file
							}
						];
					});
					console.log(this.podcastList);
				}else{
					this.podcastList_last_page = true;
				}
				});
	}

	public loadScript(url: string) {
		const body = <HTMLDivElement> document.body;
		const script = document.createElement('script');
		script.innerHTML = '';
		script.src = url;
		script.async = false;
		script.defer = true;
		body.appendChild(script);
	  }

}
